import { render, staticRenderFns } from "./bar_chart.vue?vue&type=template&id=5ace8d66&scoped=true&"
import script from "./bar_chart.vue?vue&type=script&lang=js&"
export * from "./bar_chart.vue?vue&type=script&lang=js&"
import style0 from "./bar_chart.vue?vue&type=style&index=0&id=5ace8d66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ace8d66",
  null
  
)

export default component.exports